import { createMuiTheme } from '@material-ui/core/styles';
import { darken, lighten } from 'polished';
import { typography } from 'src/config/typography';
import { colors } from 'src/config/colors';

export const muiTheme = createMuiTheme({
  palette: {
    type: 'dark',
    primary: {
      light: lighten(0.2, colors.primary),
      main: colors.primary,
      dark: darken(0.2, colors.primary),
    },
  },
  typography: {
    fontFamily: typography.fontFamilyDefault,
  },
});
